import axiosInstance from '../../../config/axiosInstance';
const CustomerHistoryService = {
    async GetAllCustomerHistory(redirectCallback, ClientCompanyID) {
        try {
            const response = await axiosInstance.get(`/Customer/GetCustomerHistory?ID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CustomerHistoryByContactID(redirectCallback, ClientContactID) {
        try {
            const response = await axiosInstance.get(`/Customer/CustomerHistoryByContactID?ID=${ClientContactID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteCustomerHistory(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Customer/DeleteCustomerHistory?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UpdateCustomerHistory(formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.FK_User_ID = UserID;
            const response = await axiosInstance.post(`/Customer/UpdateCustomerHistory`, formData);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdateCommunication(formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.FK_User_ID = UserID;
            const response = await axiosInstance.post(`/Customer/UpdateCommunication`, formData);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetAllCustomerCommunication(redirectCallback, ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {

            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "ALL";

            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllCustomerCommunication?ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;


        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CustomerCommunicationCount(redirectCallback, ClientCompanyID, searchQuery, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/CustomerCommunicationCount?ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetAllContactCommunication(redirectCallback, ClientContactID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {

            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "ALL";

            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllContactCommunication?ClientContactID=${ClientContactID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;


        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async ContactCommunicationCount(redirectCallback, ClientContactID, searchQuery, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/ContactCommunicationCount?ClientContactID=${ClientContactID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },

};

export default CustomerHistoryService;